import * as React from 'react';
import styled, { css } from 'styled-components';

import { Role } from '../../api/Permission';

interface IProps {
  /** @ignore */
  className?: string;
  /** Role to display. */
  role: Role;
  /** Show full role name? Otherwise just first letter. */
  full?: boolean;
}

const RoleBoxBase = (props: IProps) =>
  <div className={props.className} title={props.full ? "" : props.role}>
    {props.role === Role.Admin && (props.full ? "Admin" : "A")}
    {props.role === Role.PowerUser && (props.full ? "Power user" : "P")}
    {props.role === Role.User && (props.full ? "User" : "U")}
  </div>

const RoleBox = styled(RoleBoxBase)`
  // Position & size:
  box-sizing: border-box;
  min-width: 16px;
  height: 16px;
  ${p => p.full && css`
    padding-left: 6px;
    padding-right: 6px;
  `}

  // Content:
  display: flex;
  justify-content: center;
  align-items: center;

  // Appearance:
  font: ${p => p.theme.font.labelSmall};
  text-transform: uppercase;
  font-weight: 500;
  font-size: 8px;
  border-radius: 4px;
  
  background-color: #666;
  ${p => p.role == Role.Admin && css`background-color: crimson;`}
  ${p => p.role == Role.PowerUser && css`background-color: teal;`}
`

export { RoleBox }
